import { RouteObject } from 'react-router-dom'

const routes: RouteObject[] = [
  {
    path: '/contatos/criar',
    lazy: async () => {
      const { default: Component } = await import('pages/ContactsManager/Create')
      return { Component }
    },
  },
  {
    path: '/contatos/:contact_id',
    lazy: async () => {
      const { default: Component } = await import('pages/ContactsManager/Edit')
      return { Component }
    },
  },
]

export default routes
